import { WholeLifeChildPlanDetails, WholeLifePlanDetails } from "../../../../../../../types/plan.types";

export const WholeLifeInsuranceChildPlanData: WholeLifeChildPlanDetails = {
	coverage: [],
	coverage_level: [null, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000],
	premium_amount: {
		"10000": {
			WEEKLY: 0.74,
			MONTHLY: 3.2
		},
		"15000": {
			WEEKLY: 1.11,
			MONTHLY: 4.8
		},
		"20000": {
			WEEKLY: 1.48,
			MONTHLY: 6.4
		},
		"25000": {
			WEEKLY: 1.85,
			MONTHLY: 8.0
		},
		"30000": {
			WEEKLY: 2.22,
			MONTHLY: 9.6
		},
		"35000": {
			WEEKLY: 2.58,
			MONTHLY: 11.2
		},
		"40000": {
			WEEKLY: 2.95,
			MONTHLY: 12.8
		},
		"45000": {
			WEEKLY: 3.32,
			MONTHLY: 14.4
		},
		"50000": {
			WEEKLY: 3.69,
			MONTHLY: 16.0
		}
	}
};
